export const appendAndIfNeccessary = (request, paramName, param) => {
  if (request.includes('='))
    return request += `&${paramName}=${param}`;
  
  return request += `${paramName}=${param}`;
}